import './lead_block.scss';

